<template>
<div class="yo-bg-color-chiaro" style="padding:20px 10px; ">
   <div class="col s12 yo-text-xl yo-text-bold yo-spacing-s black" style="padding:20px 50px;">MODIFICA LA TUA PASSWORD</div>

  <el-form ref="form" :model="password" v-on:submit.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;">
  
    <div class="row">

    
      <div class="col s12 m6">
      <el-form-item label="Password corrente" prop="old">
        <el-input type="password" v-model="password.old"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6 clear">
      <el-form-item label="Nuova Password" prop="new">
        <el-input type="password" v-model="password.new"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Reinserisci Password" prop="retype">
        <el-input type="password" v-model="password.retype"></el-input>
      </el-form-item>
      </div> 

    </div>


   <div class="row pad">
      <div class="col s12 m4 offset-m2"><el-button style="width:100%;" @click="onCancel">Indietro</el-button></div>
      <div class="col s12 m4 offset-m2"><el-button type="primary" @click="onSubmit" style="width:100%;">Salva</el-button></div>
    </div>





  



  </el-form>
</div>
</template>

<script>
export default {
  name: 'contatto-password',
  data () {
      return {
         password:{new:'',old:'',retype:''}
         ,oldPassword: function (rule, value, callback)  {
            if(typeof value !='undefined')
            if (value.toString()!=rule.password) {
               return callback(new Error('La vecchia password non è corretta!'));
            }else{
               callback();
            }
         }
         ,retypePassword: function (rule, value, callback)  {
            if(typeof value !='undefined')
            if (value.toString()!=rule.password) {
               return callback(new Error('La nuova password non coincide con quella di controllo!'));
            }else{
               callback();
            }
         }
      }
   },
  created () {
      this.$teras.page.title = "Mylogin Profilo"
      this.$teras.page.sezione = "myLogin"
   },
  beforeDestroy () {
  },
  methods: {
    onChange(editor, content){
      console.log(".................................................................................:"+editor)
      //this.form.note = editor
    },
    onCancel() {
        this.$router.go(-1)
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          //console.log("CANCELLAZIONE "+this.form.cancellazione)




          this.Save()
        } else {
          return false;
        }
      });
    },
    Save(){
      var parent = this
      this.$contatto.row.password=this.password.new
      this.$contatto.save().then(function (data) {
        //parent.$teras.getContatto()
        parent.$router.push('/mylogin-home/')
      })
    }

  },
  computed: {
     rules:function() {
      var rulesNow = {
        old: [
          { required: true, message: 'La descrizione è obbligatoria' }
        ],
        new: [
          { required: true, message: 'L\'importo è obbligatorio'}
        ],
        old: [
          { required: true, validator: this.oldPassword, password:this.$contatto.row.password, message: 'La vecchia password non è corretta!', trigger:"change" }
        ],
        retype: [
          { required: true, validator: this.retypePassword, password:this.password.new, message: 'La nuova password non coincide con quella di controllo', trigger:"change" }
        ]    
      }
      return rulesNow
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/Contatto-password.vue